<template>
  <van-popup
    v-model:show="show"
    round
    closeable
    :style="{
      width: '90%',
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      background: '#f0f3f5',
      margin: '0 auto'
    }"
  >
    <div class="statement-bg">
      <div class="content">请从中山+打开本稿件，参与抽奖</div>
      <wx-open-launch-app
        id="launch-btn"
        appid="wxc9da92efaf026389"
        :extinfo="exinfo"
        style="width: 80%; height: 40px"
        @launch="handleLaunch"
        @error="handleError"
      >
        <component
          :is="'script'"
          type="text/wxtag-template"
        >
          <button
            style="
              background: linear-gradient(to right, #f48260, #e53531);
              border-width: 0;
              font-size: 4.5vw;
              color: #fff;
              font-weight: 400;
              text-align: center;
              width: 100%;
              height: 40px;
              border-radius: 20px;
            "
            class="btn"
          >
            <span>打开中山+客户端</span>
          </button>
        </component>
      </wx-open-launch-app>
    </div>
  </van-popup>
</template>

<script>
import { computed } from "vue";
import { Popup } from "vant";
export default {
  name: "Statement",
  components: {
    [Popup.name]: Popup
  },
  props: { showJump: Boolean, exinfo: String },
  setup(props, ctx) {
    const handleLaunch = (e) => {
      console.log("handleLaunch", e);
    };
    const handleError = (e) => {
      console.log("handleError", e);
      window.open(
        "http://www.zsnews.cn/app/mobile.html?platform=mobile",
        "_blank"
      );
    };

    return {
      show: computed({
        get() {
          return props.showJump;
        },
        set(value) {
          ctx.emit("updateJumpState", value);
        }
      }),
      exinfo: computed({
        get() {
          return props.exinfo;
        },
        set(value) {}
      }),
      handleLaunch,
      handleError
    };
  }
};
</script>

<style lang="scss" scoped>
.launch-btn-box {
  margin: 12px 0;
}
.statement-bg {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-height: 15rem;
  text-align: left;
  margin: 0.9375rem 0;
  padding: 0.3125rem 0.625rem;
  overflow-y: auto;
  .title {
    text-align: center;
    font-size: 0.5rem;
    margin-bottom: 0.5rem;
    font-weight: 600;
  }
  .content {
    text-align: justify;
    font-size: 16px;
    padding: 10px;
  }
}
</style>
